/*
 * Session 4 (1/2): homepage hero scroll indicator.
 *
 * Injected via JS (markup stays out of the Dawn section). On the homepage only
 * (<body class="template-index">), a thin drawing line + "SCROLL" label is
 * appended to the hero `.banner` (which is position:relative, so it anchors to
 * the banner's bottom-centre). The whole indicator fades out once the page is
 * scrolled past 100px and back in above it. The draw animation itself is pure
 * CSS (gated on prefers-reduced-motion there); this only builds the nodes and
 * toggles the scroll-fade class.
 */
(function () {
  'use strict';

  if (!document.body || document.body.className.indexOf('template-index') === -1) return;

  function setup() {
    // The hero is the homepage's first image-banner; grab the first .banner.
    var banner = document.querySelector('.template-index .banner') || document.querySelector('.banner');
    if (!banner) return;
    if (banner.querySelector('.elome-scroll-indicator')) return; // idempotent

    var indicator = document.createElement('div');
    indicator.className = 'elome-scroll-indicator';
    indicator.setAttribute('aria-hidden', 'true');

    var line = document.createElement('span');
    line.className = 'elome-scroll-indicator__line';

    var label = document.createElement('span');
    label.className = 'elome-scroll-indicator__label';
    label.textContent = 'SCROLL';

    indicator.appendChild(line);
    indicator.appendChild(label);
    banner.appendChild(indicator);

    var hidden = false;
    function onScroll() {
      var sy = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (sy > 100 && !hidden) {
        indicator.classList.add('elome-scroll-indicator--hidden');
        hidden = true;
      } else if (sy <= 100 && hidden) {
        indicator.classList.remove('elome-scroll-indicator--hidden');
        hidden = false;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }
})();

